/**
 * @prettier
 * @flow
 */
export const PaymentLinkStatuses = Object.freeze({
    ACTIVE: 'ACTIVE',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
});

export type PaymentLinkStatus = $Values<typeof PaymentLinkStatuses>;
